export function databookRowWindow(offsets: number[], top: number, height: number) {
  const firstAtOrAfter = (position: number) => {
    let left = 0;
    let right = offsets.length;
    while (left < right) {
      const middle = Math.floor((left + right) / 2);
      if (offsets[middle] < position) left = middle + 1; else right = middle;
    }
    return left;
  };
  return {
    start: Math.max(0, firstAtOrAfter(top - 200) - 1),
    end: Math.min(offsets.length - 1, firstAtOrAfter(top + height + 200)),
  };
}
